// import apiClient from './api_client_requests'; //? unused

export default config => {
    return async payload => {
        const userSessionKey = 'wa360_session';
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = domain => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain
                .split('.')
                .slice(-2)
                .join('.');
        };

        const unSetCookieByName = cookieName => {
            if (typeof document === 'undefined') {
                return;
            }
            const expiryString =
                '= invalid; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Max-Age=-99999999';
            return (document.cookie = `${cookieName}${expiryString}; Path=/; Domain=${getTopLevelDomain(
                document.location.hostname
            )}`);
        };

        // remove cookies
        unSetCookieByName(appCookieKey);
        unSetCookieByName(sharedCookieKey);

        // remove local storage session info
        localStorage.removeItem(userSessionKey);

        return {
            loggedIn: false,
        };
    };
};
